var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 30C55.5 16.2 44.3 5 30.5 5C16.7 5 5.5 16.2 5.5 30C5.5 42.1 14.1 52.175 25.5 54.5V37.5H20.5V30H25.5V23.75C25.5 18.925 29.425 15 34.25 15H40.5V22.5H35.5C34.125 22.5 33 23.625 33 25V30H40.5V37.5H33V54.875C45.625 53.625 55.5 42.975 55.5 30Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "homepage/static/media/facebook.e383b2bf885d0d06816bb2773d993b82.svg";
export { ForwardRef as ReactComponent };